export const user_state = {
	user: {
		token: null,
	}
};
